import React from 'react';
import { useStyles } from './footer.jss';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';

export const Footer: React.FunctionComponent<{
  compensateForMargins?: boolean;
}> = React.memo(props => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Paper
        className={classNames(classes.container, {
          [classes.containerExtendMargins]: props.compensateForMargins,
        })}
        square={true}
      >
        {props.children}
      </Paper>
    </React.Fragment>
  );
});
